// OtpVerification.js — corrected
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UpdateToServer } from "../api/ServerApi";



const OtpVerification = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // ✅ moved inside component

  useEffect(() => {
    // Only auto-redirect to /main when OTP is verified AND
    // we're NOT currently on /smartsearch (prevents redirect when visiting /smartsearch).
    if (
      localStorage.getItem("OtpVerified") === "true" &&
      location.pathname !== "/smartsearch"
    ) {
      navigate("/main", { replace: true });
    }
  }, [navigate, location.pathname]);

  const handleVerifyOtp = async () => {
    const stored = localStorage.getItem("Otp")?.trim();
    const entered = otp.trim();

    if (!entered) {
      alert("Enter OTP");
      return;
    }

    if (entered !== stored) {
      alert("Wrong OTP!");
      return;
    }

    const userId = localStorage.getItem("TempUserId");
    const mobile = localStorage.getItem("TempMobile");
    const password = localStorage.getItem("TempPassword");
    const deviceId = localStorage.getItem("device_id");

    try {
      // Update backend with device ID
    await UpdateToServer("UpdateUsers", {
  UserId: userId,
  LaptopDeviceId: deviceId,
});

    } catch (err) {
      console.error("UpdateUsers failed", err);
      // optionally show error to user or continue — adjust as desired
    }

    // Save final login details
    localStorage.setItem("UserId", userId);
    localStorage.setItem("MobileNumber", mobile);
    localStorage.setItem("Password", password);
    localStorage.setItem("LastLoginDeviceId", deviceId);
    localStorage.setItem("OtpVerified", "true");

    // Clear temp
    localStorage.removeItem("TempUserId");
    localStorage.removeItem("TempMobile");
    localStorage.removeItem("TempPassword");

    alert("OTP Verified!");
    navigate("/main", { replace: true });
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.title}>Verify OTP</div>
        <div style={styles.loginBox}>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={styles.input}
          />
          <button
            onClick={handleVerifyOtp}
            style={{ ...styles.button, ...styles.verify }}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  body: {
    backgroundImage:
      'url("https://wallpapers.com/images/hd/usa-chicago-riverwalk-at-night-1jaq0bwc5dc0g6n0.jpg")',
    backgroundSize: "cover",
    height: "100vh",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    flexDirection: "column",
  },
  title: {
    fontSize: "48px",
    color: "white",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  loginBox: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    width: "340px",
    borderRadius: "8px",
  },
  input: {
    width: "100%",
    padding: "14px",
    margin: "10px 0",
    borderRadius: "6px",
  },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  verify: { background: "#1877f2", color: "white" },
};

export default OtpVerification;
